"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobDeliveryAccountingLogic = void 0;
const typeorm_1 = require("typeorm/browser");
let JobDeliveryAccountingLogic = class JobDeliveryAccountingLogic {
};
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'job_api_id' }),
    __metadata("design:type", String)
], JobDeliveryAccountingLogic.prototype, "jobApiId", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({ name: 'delivery_date' }),
    __metadata("design:type", Date)
], JobDeliveryAccountingLogic.prototype, "deliveryDate", void 0);
JobDeliveryAccountingLogic = __decorate([
    (0, typeorm_1.ViewEntity)({
        name: 'job_delivery_accounting_logic',
        schema: 'analytics',
        materialized: true,
        expression: `
    SELECT DISTINCT ON (j.api_id__c)
      j.api_id__c AS job_api_id,
      CASE
        WHEN j.date_end__c IS NOT NULL THEN j.date_end__c::TIMESTAMPTZ AT TIME ZONE 'UTC'
        WHEN j.appointment_customer_end__c IS NOT NULL THEN j.appointment_customer_end__c::TIMESTAMPTZ AT TIME ZONE 'UTC'
        WHEN j.appointment_customer_start__c IS NOT NULL THEN j.appointment_customer_start__c::TIMESTAMPTZ AT TIME ZONE 'UTC'
        ELSE j.createddate
      END AS delivery_date
    FROM public.job__c j
    WHERE j.status__c NOT IN ('cancelled', 'closed')
  `,
    })
], JobDeliveryAccountingLogic);
exports.JobDeliveryAccountingLogic = JobDeliveryAccountingLogic;
//# sourceMappingURL=materialized-job-delivery-accounting-logic.js.map